export default __webpack_public_path__ + "static/media/InsureBox-banner.31df7766.png";